import { AdjustmentCategory, AdjustmentFrequency, AwsAdjustment, OnPremAdjustment } from '@amzn/awscat-portfolio-assessment-types';

export enum AdjustmentType {
    AWS = 'AWS',
    ON_PREMISES = 'On-Premises'
}

export type AdjustmentItem = {
    portfolioId: string;
    tcoAssessmentId: string;
    adjustmentId: string;
    title: string;
    category: AdjustmentCategory;
    description: string;
    amount: number;
    frequency: AdjustmentFrequency;
    inScope: boolean;
    createdBy: string;
    createdAt: Date;
} & ({type: AdjustmentType.AWS; awsSupport: boolean} | {type: AdjustmentType.ON_PREMISES});

export type ForwardRefFnType = {
    validate: () => Promise<boolean>;
    getAdjustment: () => AwsOnPremAdjustment | null;
};

export type AwsOnPremAdjustment = AwsAdjustment | OnPremAdjustment;

export type SelectOption = {label: string, value: string};

export type AdjustmentItemSelected = AdjustmentItem & {selected: boolean};
